import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IFeedService {
    getNotificationUnreadCount: () => Observable<number>;
    getUnreadCountObservable: () => Observable<number>;
}

export const FEED_SERVICE = new InjectionToken<IFeedService>('FEED_SERVICE');
